export default [
  {
    path: '/import',
    name: 'importIndex',
    component: () => import('@/views/Import/Index.vue'),
    meta: {
      layout: 'content'
    }
  }
]

